const IsProd = process.env.REACT_APP_ENV === "production";

export const logger = {
	info: (...args) => {
		if (!IsProd) console.log("[INFO]", ...args);
	},
	error: (...args) => {
		if (!IsProd) console.error("[ERROR]", ...args);
	},
	warn: (...args) => {
		if (!IsProd) console.warn("[WARN]", ...args);
	},
	log: (...args) => {
		if (!IsProd) console.log(...args);
	}
}